import React from "react";
import ResetPasswordForm from "@/components/auth/reset-password";

const ResetPassword: React.FC = () => {
    return <ResetPasswordForm />;
};

export default ResetPassword;
